import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { PageResponse, Pagination } from '@core/shared/domain';
import { QueryParams } from '@core/shared/util';

import { HitList, HitListArticle } from '../models';

@Injectable()
export class HitListsService {
  private readonly baseUrl = '/api/medical-shop2/hitlists';

  constructor(private readonly http: HttpClient) {}

  /**
   * Fetches all cost centers containing frequently ordered articles in the last 60 days
   * @returns All hit lists
   */
  fetchHitLists(): Observable<PageResponse<HitList>> {
    const params = QueryParams.build().noPaginationSupported().toHttpParams();

    return this.http.get<PageResponse<HitList>>(`${this.baseUrl}`, { params });
  }

  /**
   * Fetches the most frequently ordered articles of a cost center for the last 60 days
   * @param costCenterId The ID of the cost center
   * @param pagination The pagination parameters
   * @returns The most frequently ordered articles of a cost center
   */
  fetchHitListArticles(costCenterId: string, pagination?: Pagination): Observable<PageResponse<HitListArticle>> {
    const params = QueryParams.build()
      .page(pagination?.page ?? 1)
      .pageSize(pagination?.pageSize ?? 50)
      .toHttpParams();

    return this.http.get<PageResponse<HitListArticle>>(`${this.baseUrl}/${costCenterId}/articles`, { params });
  }
}
